import ScrollSection from 'components/ScrollSection';
import ReceptionForm from './ReceptionForm';

const ReceptionSettings = () => {
  return (
    <ScrollSection>
      <ReceptionForm />
    </ScrollSection>
  );
};

export default ReceptionSettings;
